export default "__VITE_ASSET__DRZ7GdgZ__"